import InvoiceDetailsStore from '../InvoiceDetailsStore';
import LayoutStore from '../LayoutStore';
import { IModalStore, ModalType } from '../ModalStore';
import { Line, LineGroup } from '../models/InvoiceDetails';

export default class InvoiceDetailsTableViewStore {
  constructor(
    private invoiceDetailsStore: InvoiceDetailsStore,
    private layoutStore: LayoutStore,
    private modalStore: IModalStore
  ) {}

  public get isAllowedToShowUsages(): boolean {
    return !this.invoiceDetailsStore.isCurrentInvoiceRestricted && this.invoiceDetailsStore.invoiceDetailsRequest.invoiceServiceDetailsAccess;
  }

  public hasUsages(line: Line): boolean {
    if (line.hasUsages && line.lineUnit && line.lineUnit.search('[BБ]$') !== -1 && line.lineTotalSum === 0) {
      return false;
    }
    return line.hasUsages;
  }

  public toggleableLineGroupNameSuffix(lineGroup: LineGroup): string {
    let lineGroupCount = 0;
    let lineCount = 0;
    if (lineGroup.lineGroups) {
      lineGroupCount = lineGroup.lineGroups.length;
    }
    if (lineGroup.lines) {
      lineCount = lineGroup.lines.length;
    }
    return InvoiceDetailsTableViewStore.addBracketsToBothEnds((lineGroupCount + lineCount).toString());
  }

  public toggleableLineNameSuffix(line: Line): string {
    if (line.lineQty) {
      return InvoiceDetailsTableViewStore.addBracketsToBothEnds(line.lineQty.toString());
    }
    return '';
  }

  public formatAsVolume(line: Line): string {
    if (!line.formattedLineDuration) {
      return null;
    }
    if (!line.lineUnit) {
      return line.formattedLineDuration;
    }
    return `${line.formattedLineDuration} ${line.lineUnit}`;
  }

  public getFormattedLineDurationOrQuantity(line: Line): string {
    if (line.formattedLineDuration) {
      return this.formatAsVolume(line);
    }
    return this.invoiceDetailsStore.formatAsQuantity(line.lineQty);
  }

  public onToggleableLineClick(toggleableLine: Line, activeLineUsagesId: string): void {
    this.invoiceDetailsStore.setActiveLineUsages(toggleableLine);
    this.invoiceDetailsStore.setActiveLineUsagesId(activeLineUsagesId);

    if (this.layoutStore.isMobile) {
      this.modalStore.openModal(ModalType.InvoiceLineUsagesModal);
    }
  }

  public filterColumnsByLayout(columns: JSX.Element[]): JSX.Element[] {
    return columns
      .filter((column: JSX.Element) => (this.layoutStore.isMobile ? column.key.toString().search('^desktop') === -1 : true))
      .map((column) => {
        return column;
      });
  }

  public getColSpan(): number {
    return this.layoutStore.isMobile ? 2 : 4;
  }

  public getToggleableLineIcon(): string {
    return this.layoutStore.isMobile ? '#arrow-right' : '#arrow-down';
  }

  private static addBracketsToBothEnds(lineCount: string) {
    return ` (${lineCount})`;
  }
}
